import _ from 'lodash';

export const getDetailPageEventState = state => _.get(state, 'detailPageEvent');
export const getTranslateState = state => _.get(state, 'translations');
export const getAssetState = state => _.get(state, 'asset');
export const getMetadata = state => _.get(state, 'metadata');
